<template>
  <div class="black-menu">
    <div class="inside">
      <ul id="slick-in" :class="['slick-in', { 'fire-slick': isSticky }]">
        <li
          v-if="
            baseUrl == '/solutions' &&
            ($breakpoints.isMobile() || $breakpoints.isTablet())
          "
          class="onlyMobile"
        >
          <a :href="baseUrl">Multiple Disciplines</a>
        </li>
        <!-- <li
          v-if="
            baseUrl == '/markets' && ($breakpoints.isMobile() || $breakpoints.isTablet())
          "
          class="onlyMobile"
        >
          <a :href="baseUrl">Six Specialties<Specialties></Specialties></a>
        </li> -->
        <li
          v-if="
            baseUrl == '/agency' && ($breakpoints.isMobile() || $breakpoints.isTablet())
          "
          class="onlyMobile"
        >
          <a :href="baseUrl">Welcome to Marcus Thomas<Specialties></Specialties></a>
        </li>

        <template v-if="baseUrl == '/inclusion'">
          <li v-for="(index, i) in moreList" :key="i">
            <a
              :class="
                $route.path == baseUrl + '/' + index.elements.url.value
                  ? 'item active'
                  : 'item'
              "
              :href="baseUrl + '/' + index.elements.url.value"
              :data-slide="i"
              >{{ index.elements.page_name.value }}</a
            >
          </li>
        </template>

        <template v-else>
          <li v-for="(index, i) in moreList" :key="i">
            <a
              :class="
                $route.path == baseUrl + '/' + index.elements.url.value
                  ? 'item active'
                  : 'item'
              "
              :href="baseUrl + '/' + index.elements.url.value"
              :data-slide="i"
              >{{ index.elements.header_title.value }}</a
            >
          </li>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "subMenu",
  props: ["moreList", "baseUrl", "isSticky"],
};
</script>



// WEBPACK FOOTER //
// submenu.vue?c330a3a2